import { render, staticRenderFns } from "./RasmusForgotPassword.vue?vue&type=template&id=444e3769&"
import script from "./RasmusForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./RasmusForgotPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports